/**
 * Realtime (Socket.IO) contract. Connect with
 * `io({ path: REALTIME_PATH, auth: { token: <access token> } })`; the server joins the socket to
 * its user, tenant and (for Super Admins) platform rooms. Payloads are hints to refetch: the API
 * remains the source of truth.
 */
export const REALTIME_PATH = '/api/v1/realtime';
export const REALTIME_EVENTS = {
    /** module entitlements or roles changed: refetch /me and /me/navigation */
    navigationChanged: 'navigation.changed',
    usersChanged: 'users.changed',
    rolesChanged: 'roles.changed',
    notificationCreated: 'notification.created',
    /** this session was revoked (password change, admin action): sign out */
    sessionRevoked: 'session.revoked',
    jobsChanged: 'jobs.changed',
    tenantsChanged: 'tenants.changed',
    /** an opportunity moved or changed: refetch the board / account (M3-04) */
    pipelineChanged: 'pipeline.changed',
    playbookChanged: 'playbook.changed',
    libraryChanged: 'library.changed',
    importChanged: 'import.changed',
};
//# sourceMappingURL=events.js.map